import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
} from '@angular/core';
import { IconComponent } from '@pedix-workspace/angular-ui-icons';
import clsx from 'clsx';

export const tagSizes = ['xs', 'sm', 'md', 'lg'] as const;
export const tagTypes = ['neutral', 'info', 'warning', 'danger', 'success'] as const;
export const tagAppareances = ['solid', 'bare', 'accented'] as const;

export type TagSizes = typeof tagSizes;
export type TagSize = TagSizes[number];

export type TagTypes = typeof tagTypes;
export type TagType = TagTypes[number];

export type TagAppareances = typeof tagAppareances;
export type TagAppareance = TagAppareances[number];

@Component({
  selector: 'pxw-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class TagComponent implements AfterContentInit {
  @ContentChild(IconComponent) icon: IconComponent;

  @Input() size: TagSize = 'sm';
  @Input() type: TagType = 'info';
  @Input() appareance: TagAppareance = 'solid';
  @Input() uppercase = true;

  @HostBinding('class')
  get classes() {
    return clsx(`size-${this.size}`, `type-${this.type}`, `appareance-${this.appareance}`, {
      uppercase: this.uppercase,
    });
  }

  ngAfterContentInit(): void {
    if (this.icon) {
      this.icon.size = this.size;
    }
  }
}
